function n(n){var e;return function(){return e||(e=new Promise((function(o){Promise.resolve().then((function(){e=void 0,o(n())}))}))),e}}export{n as default};
